import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";

export default class SortHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "sort":
                return this.handleChange(model, params);
            default:
                return model;
        }
    }

    private handleChange(model: DiscussionModel, sort: string): DiscussionModel {

        if (model.getSort() != sort) {
            this.dispatch("load/start");
            model = model.setSort(sort);
        }

        return model;

    }

}